// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"391":"info","607":"santa-list","623":"tree","884":"admin","977":"security"}[chunkId] + "." + {"391":"4558f10f","607":"043bde6b","623":"51bf9a51","884":"84c623c9","977":"a74b0cee"}[chunkId] + ".css";
};